import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
  useLocation,
} from "react-router-dom";
import NotFound from "./Components/NotFound";
import MainLayout from "./Layout/MainLayout";
import CompanyForm from "./Pages/CompanyForm";
import Dashboard from "./Pages/Dashboard";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import StudentForm from "./Pages/StudentForm";
import Test from "./Pages/Test";

import { engApi } from "./api/engApi";
import { useDispatch, useSelector } from "react-redux";
import { updateIsMember, updateProfile } from "./redux/action/profileAction";
import Profile from "./Pages/Profile";
import CompanyDetail from "./Pages/CompanyDetail";
import Company from "./Pages/Company";
import Task from "./Pages/administrator/Task";
import CompanyReview from "./Pages/administrator/CompanyReview";
import Approval from "./Pages/administrator/Approval";
import DocumentRequest from "./Pages/DocumentRequest";
import InternshipAnswer from "./Pages/administrator/InternshipAnswer";
import DrawerLayout from "./Layout/DrawerLayout";
import { MessengerChat } from "react-messenger-chat-plugin";
import DashboardCompany from "./Pages/DashboardCompany";
import InternForm from "./Pages/InternForm";
import StudentManagement from "./Pages/administrator/StudentManagement";
import JobRequest from "./Pages/JobRequest";
import EventDetail from "./Pages/EventDetail";
import Event from "./Pages/Event";

import ActivityLog from "./Pages/ActivityLog";
import EventById from "./Pages/EventById";
import { Alert, Snackbar } from "@mui/material";
import { updateSnackbar } from "./redux/action/dataAction";
import Manual from "./Pages/Manual";
import InternManual from "./Pages/InternManual";
import DashboardInternship from "./Pages/administrator/DashboardInternship";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getUsername = localStorage.getItem("username");
  // const getUsername = 55050419;
  const profile = useSelector((state) => state.profileReducer.profile);
  const snackbar = useSelector((state) => state.dataReducer.snackbar);

  const getStudentDetail = async () => {
    try {
      const response = await engApi.get("/all-student/");

      const user = response.data.find((st) => st.id == getUsername);
      dispatch(updateProfile(user));

      const resMember = await engApi.get("/intern-student/");

      const isMember = resMember.data.find((el) => el.id == getUsername);

      if (user && isMember) {
        // navigate("/");
        // dispatch(updateIsMember(true));
      } else if (user && !isMember) {
        navigate("/student-form");
        // dispatch(updateIsMember(false));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffDetail = async () => {
    try {
      const response = await engApi.get("/all-staff/");

      const user = response.data.find((st) => st.id == getUsername);

      dispatch(updateProfile(user));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isNaN(getUsername)) {
      getStaffDetail();
    } else {
      getStudentDetail();
    }
  }, []);

  const ProtectedRoute = ({ profile, redirectPath = "/" }) => {
    if (
      (profile && profile.m_role == "staff") ||
      window.location.hostname == "localhost"
    ) {
      return <Outlet />;
    }

    return <Navigate to={redirectPath} replace />;
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch(
      updateSnackbar({
        open: false,
        content: "",
      })
    );
  };

  return (
    <>
      <MessengerChat pageId="291328901489840" />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar?.open || false}
        onClose={handleCloseSnack}
        autoHideDuration={2000}
      >
        <Alert
          onClose={handleCloseSnack}
          severity={snackbar?.severity ?? "success"}
          sx={{ width: "100%" }}
        >
          {snackbar?.content || ""}
        </Alert>
      </Snackbar>

      <Routes>
        <Route path="/" element={<DrawerLayout />}>
          <Route element={<ProtectedRoute profile={profile} />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard-company" element={<DashboardCompany />} />
            <Route
              path="/dashboard-internship"
              element={<DashboardInternship />}
            />
            <Route path="/task" element={<Task />} />
            <Route path="/approval" element={<Approval />} />
            <Route path="/internship-answer" element={<InternshipAnswer />} />
            <Route path="/student-manage" element={<StudentManagement />} />
          </Route>
          <Route path="/intern-manual" element={<InternManual />} />
          <Route index element={<Home />} />
          <Route path="/manual" element={<Manual />} />
          <Route path="/student-form" element={<StudentForm />} />
          <Route path="/request-form" element={<CompanyForm />} />
          <Route path="/job-request" element={<JobRequest />} />
          <Route path="/company-detail" element={<CompanyDetail />} />
          <Route path="/profile" element={<Profile />} />

          <Route path="/company-review" element={<CompanyReview />} />
          <Route path="/company/:id" element={<Company />} />
          <Route path="/event" element={<Event />} />
          <Route path="/event-detail" element={<EventById />} />

          <Route path="/activity-log" element={<ActivityLog />} />

          {/* <Route path="/event-details" element={<EventDetail />} /> */}
          {/* <Route path="/event-details/:id" element={<EventDetail />} /> */}
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/document-request" element={<DocumentRequest />} />
        <Route path="/intern-form" element={<InternForm />} />

        <Route path="/login" element={<Login />} />
        <Route path="/test" element={<Test />} />
      </Routes>
    </>
  );
};

export default App;
